import { TweenLite } from "gsap/TweenMax";

export class SmoothScrollModule {
	targetElmList: NodeList = document.querySelectorAll("body, [data-scroll-viewport],[data-scroll-container]");
	targetElArray: HTMLElement[] = Array.prototype.slice.call(this.targetElmList);

	constructor() {
		if (window.innerWidth > 500) {
			this.browserDetect();
		}
	}
	private browserDetect = () => {
		const detectIE = () => {
			const ua = window.navigator.userAgent;
			const trident = ua.indexOf("Trident/");
			const msie = ua.indexOf("MSIE");
			const edge = ua.indexOf("Edge/");

			if (!(msie > 0 || trident > 0 || edge > 0)) {
				this.smoothScroll();
				this.smoothScrollStyling();
			}
			return false;
		};
		detectIE();
	}
	private smoothScroll = () => {
		const html = document.documentElement;
		const body = document.body;

		const scroller = {
			target: document.querySelector("[data-scroll-container]"),
			ease: 0.18, // <= scroll speed
			endY: 0,
			y: 0,
			resizeRequest: 1,
			scrollRequest: 0,
		};

		let requestId: number | null = null;
		TweenLite.set(scroller.target, {
			rotation: 0.01,
			force3D: true,
		});

		const updateScroller = () => {
			const resized = scroller.resizeRequest > 0;
			if (resized) {
				const height = scroller.target.clientHeight;
				body.style.height = height + "px";
				scroller.resizeRequest = 0;
			}

			const scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;

			scroller.endY = scrollY;
			scroller.y += (scrollY - scroller.y) * scroller.ease;

			if (Math.abs(scrollY - scroller.y) < 0.05 || resized) {
				scroller.y = scrollY;
				scroller.scrollRequest = 0;
			}

			TweenLite.set(scroller.target, {
				y: -scroller.y,
			});

			requestId = scroller.scrollRequest > 0 ? requestAnimationFrame(updateScroller) : null;
		};
		const onScroll = () => {
			scroller.scrollRequest++;
			if (!requestId) {
				requestId = requestAnimationFrame(updateScroller);
			}
		};
		const onResize = () => {
			scroller.resizeRequest++;
			if (!requestId) {
				requestId = requestAnimationFrame(updateScroller);
			}
		};
		const onLoad = () => {
				updateScroller();
				window.focus();
				window.addEventListener("resize", onResize);
				document.addEventListener("scroll", onScroll);
		};
		setTimeout(() => {
			onLoad();
		}, 500);
	}
	private smoothScrollStyling = () => {
		this.targetElArray.forEach((element: HTMLElement) => {
			element.classList.add("init-smooth-scroll");
		});
	}
}